import 'core-js/stable';
import { hydrateRoot } from 'react-dom/client';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App, { type AppConfig } from './App/App';
import {
  SELECTED_ACCOUNT_KEY,
  SELECTED_SEEK_ACCOUNT_KEY,
} from './constants/userAccountKeys';
import configurationService from './services/configurationService';
import { setItem } from './utils/localStorage';
import { parse } from 'query-string';

if (configurationService.isLocalDev()) {
  const parsed = parse(location.search);
  const accountId = (parsed.id || parsed.jobid) ?? '12345';
  const seekId = '67890';
  setItem(SELECTED_ACCOUNT_KEY, accountId as string);
  setItem(SELECTED_SEEK_ACCOUNT_KEY, seekId);
}

const history = createBrowserHistory();

export default ({ config }: { config: AppConfig }) => {
  hydrateRoot(
    document.getElementById('app')!,
    <Router history={history}>
      <App config={config} />
    </Router>,
  );
};
